import ProfileModal from './ProfileModal.jsx';
import './ProfileModal.css';

export default ProfileModal;
